import { Skeleton } from "@/shared/ui/skeleton";

export function ReportGallerySkeleton() {
  return (
    <div className="flex flex-col md:flex-row h-[calc(100vh-244px)] min-h-[600px] gap-0 border border-border rounded-lg overflow-hidden bg-card">
      <div className="md:w-[280px] border-b md:border-b-0 md:border-r border-border p-4 space-y-3">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <div className="space-y-3 pt-2">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-4 rounded" />
              </div>
              <div className="space-y-1.5 pl-4">
                <Skeleton className="h-3.5 w-28" />
                <Skeleton className="h-3.5 w-36" />
                <Skeleton className="h-3.5 w-24" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex-1 flex flex-col bg-background overflow-hidden">
        <div className="flex items-center justify-between px-4 py-2 border-b border-border">
          <Skeleton className="h-4 w-12" />
          <div className="flex items-center gap-2">
            {Array.from({ length: 6 }).map((_, index) => (
              <Skeleton key={index} className="h-4 w-4 rounded" />
            ))}
          </div>
        </div>
        <div className="flex-1 bg-muted/20 p-4">
          <Skeleton className="h-full w-full rounded" />
        </div>
        <div className="border-t border-border px-4 py-3">
          <div className="flex gap-2">
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} className="h-16 w-20 shrink-0 rounded" />
            ))}
          </div>
        </div>
      </div>

      <div className="md:w-[320px] border-t md:border-t-0 md:border-l border-border p-4 space-y-4">
        <div className="space-y-2">
          <Skeleton className="h-3 w-36" />
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-3 w-20" />
        </div>
        <div className="space-y-3 pt-2">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="space-y-1">
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-4 w-44" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
